import React, { FC, useEffect, useState } from "react";

export const ChatbotLoader: FC = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setTimedOut(true);
    }, 30000);

    const checkInterval = setInterval(() => {
      if (document.getElementById("chatbase-bubble-button")) {
        setIsLoaded(true);
        clearTimeout(timeout);
        clearInterval(checkInterval);
      }
    }, 300);

    return () => {
      clearTimeout(timeout);
      clearInterval(checkInterval);
    };
  }, []);

  if (isLoaded || timedOut) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 flex h-[55px] w-[55px] items-center justify-center gap-1 rounded-full bg-primary-content p-2 shadow-lg">
      <span className="h-1.5 w-1.5 shrink-0 animate-bounce rounded-full bg-primary duration-300" />
      <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-primary duration-300 animation-delay-150" />
      <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-primary duration-300 animation-delay-300" />
    </div>
  );
};
